<template>
  <LayoutBasePage :bg-color="appStore?.apiData?.JobsiteSettings?.BgColor">
    <template #header>
      <LayoutBaseHeader
        :logo-path="appStore?.apiData?.LogoPath ?? ''"
        :title="appStore?.apiData?.JobInfo?.JobTitle ?? ''"
        :sub-title="appStore?.apiData?.CompanyName ?? ''"
        :dir="appStore?.dir"
        @titleClick="titleClick"
      ></LayoutBaseHeader>
    </template>
    <slot></slot>
  </LayoutBasePage>
</template>

<script setup lang="ts">
import { useApp } from '~/store/useApp';

const appStore = useApp();

const route = useRoute();
function titleClick() {
  console.log('title click');

  if (route.fullPath.includes('/apply')) {
    window.location.href = `/vacancy/${route.params.shortlinkId}`;
  }
}
</script>

<style scoped></style>
